import { useEffect, useState } from 'react';
import type { WidgetProps } from '@frontend/widgets/types';
import { fetchWidgetData } from '../api';

interface WorkPackage {
	id: number;
	subject: string;
	status: string;
	project: string;
	updatedAt: string | null;
	href: string | null;
}

export default function OpenProjectWorkPackagesWidget({ contextType, contextId, ecosystemId }: WidgetProps) {
	const [packages, setPackages] = useState<WorkPackage[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');

	useEffect(() => {
		setLoading(true);
		setError('');
		const params: Record<string, string> = { ecosystemId, contextType, contextId };

		fetchWidgetData<{ workPackages: WorkPackage[] }>('openproject-work-packages', params)
			.then((d) => setPackages(d.workPackages || []))
			.catch((err: Error) => setError(err.message))
			.finally(() => setLoading(false));
	}, [contextType, contextId, ecosystemId]);

	if (loading) return <div className="widget-inner-loading">Loading work packages…</div>;
	if (error) return <div className="widget-inner-error">{error}</div>;
	if (!packages.length) return <div className="widget-inner-empty">No work packages found.</div>;

	return (
		<ul className="widget-list">
			{packages.map((wp) => (
				<li key={wp.id} className="widget-list-item">
					<div className="widget-list-primary">
						{wp.href
							? <a href={wp.href} target="_blank" rel="noopener noreferrer">{wp.subject}</a>
							: <span>{wp.subject}</span>
						}
					</div>
					<div className="widget-list-meta">
						<span className="widget-status-badge">{wp.status}</span>
						<span>{wp.project}</span>
						{wp.updatedAt && <span>{new Date(wp.updatedAt).toLocaleDateString()}</span>}
					</div>
				</li>
			))}
		</ul>
	);
}
